"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.continueIfPreconditionFailed = exports.getFailingPrecondition = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var _GeolocationHelper = _interopRequireWildcard(require("../helpers/GeolocationHelper"));

var _config = _interopRequireDefault(require("../../targets/cord_eurofh_teams/config.js"));

var timers = {};
var context = null;

var getValueFromStringValue = function getValueFromStringValue(val) {
  if (val.length >= 2) {
    var firstSymbol = val[0];
    var lastSymbol = val[val.length - 1];

    if (firstSymbol === lastSymbol && (firstSymbol === '"' || firstSymbol === '\'')) {
      // it's a string
      return val.substring(1, val.length - 1);
    }

    if (firstSymbol === '@') {
      // it's a geolocation
      return val.substring(1);
    }
  }

  if (!isNaN(val)) {
    // it's a number
    return Number(val);
  }

  if (isDate(val)) {
    return new Date(val).getTime();
  }

  if (val === 'true') {
    return true;
  }

  if (val === 'false') {
    return false;
  }

  if (val === 'null' || val === 'undefined') {
    return null;
  }

  if (context && context[val] !== undefined) {
    return context[val];
  } // otherwise it's a link to a data store entry


  return _DataStore["default"].getElementByPathImmediately(val);
};

var isDate = function isDate(date) {
  var _regExp = new RegExp('^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$');

  return _regExp.test(date);
};

var getRadiusInMetersFromString = function getRadiusInMetersFromString(val) {
  var unitLength = 0;
  var multiplier = 1; // don't change this order

  if (val.endsWith(_GeolocationHelper.RADIUS_UNITS.KILOMETER)) {
    unitLength = _GeolocationHelper.RADIUS_UNITS.KILOMETER.length;
    multiplier = 1000;
  } else if (val.endsWith(_GeolocationHelper.RADIUS_UNITS.METER)) {
    unitLength = _GeolocationHelper.RADIUS_UNITS.METER.length;
    multiplier = 1;
  }

  var numberString = val.substring(0, val.length - unitLength);
  var distance = null;

  if (!isNaN(numberString)) {
    // it really is a number
    distance = Number(numberString) * multiplier;
  }

  return distance;
};

var checkEquals = function checkEquals(val1, val2) {
  return getValueFromStringValue(val1) === getValueFromStringValue(val2);
};

var checkNotEqual = function checkNotEqual(val1, val2) {
  return getValueFromStringValue(val1) !== getValueFromStringValue(val2);
};

var checkGreaterThan = function checkGreaterThan(val1, val2) {
  return getValueFromStringValue(val1) > getValueFromStringValue(val2);
};

var checkGreaterOrEqual = function checkGreaterOrEqual(val1, val2) {
  return getValueFromStringValue(val1) >= getValueFromStringValue(val2);
};

var checkLessThan = function checkLessThan(val1, val2) {
  return getValueFromStringValue(val1) < getValueFromStringValue(val2);
};

var checkLessOrEqual = function checkLessOrEqual(val1, val2) {
  return getValueFromStringValue(val1) <= getValueFromStringValue(val2);
};

var checkMatches = function checkMatches(val1, val2) {
  return String(getValueFromStringValue(val1)).match(getValueFromStringValue(val2));
};

var checkNotMatches = function checkNotMatches(val1, val2) {
  return !checkMatches(val1, val2);
};

var checkIsEmpty = function checkIsEmpty(val1) {
  // console.warn('The precondition check "isEmpty" is deprecated. Please use "doesNotExist" instead and check if the behaviour is still as expected.')
  var val = getValueFromStringValue(val1);

  if (!val || typeof val === 'undefined') {
    return true;
  }

  return String(val) === val && val.trim().length === 0;
};

var checkIsNotEmpty = function checkIsNotEmpty(val1) {
  // console.warn('The precondition check "isNotEmpty" is deprecated. Please use "exists" instead and check if the behaviour is still as expected.')
  var val = getValueFromStringValue(val1);
  return String(val) === val && val.trim().length > 0;
};

var checkExists = function checkExists(val1) {
  var val = getValueFromStringValue(val1);
  return val !== null && val !== undefined;
};

var checkDoesNotExist = function checkDoesNotExist(val1) {
  var val = getValueFromStringValue(val1);
  return val === null || val === undefined;
};

var arrayIncludesFeature = function arrayIncludesFeature(val1, val2) {
  var val = getValueFromStringValue(val1);

  if (!val) {
    return false;
  }

  return (0, _values["default"])(val).some(function (feature) {
    if (feature && feature.name === getValueFromStringValue(val2)) {
      return true;
    }
  });
};

var arrayIncludes = function arrayIncludes(val1, val2) {
  var val = getValueFromStringValue(val1);

  if (val) {
    return (0, _values["default"])(val).some(function (arrayValue) {
      if (arrayValue === getValueFromStringValue(val2)) {
        return true;
      }
    });
  }

  return false;
};

var arrayNotIncludes = function arrayNotIncludes(val1, val2) {
  return !arrayIncludes(val1, val2);
};

var checkGeolocationInRadius = function checkGeolocationInRadius(val1, val2, operator2, val3) {
  if (operator2 !== 'around') {
    console.error("unknown second operator ".concat(operator2, " in precondition check"));
    return false;
  }

  var geolocation = getValueFromStringValue(val1);
  var radiusInMeter = getRadiusInMetersFromString(val2);
  var referenceLocation = getValueFromStringValue(val3);

  if (!geolocation || !referenceLocation) {
    return false;
  }

  return _GeolocationHelper["default"].isInRadius(geolocation, referenceLocation, radiusInMeter);
};

var checkGeolocationNotInRadius = function checkGeolocationNotInRadius(val1, val2, operator2, val3) {
  /**
   *   don't simply call
   *      return !checkGeolocationInRadius(val1, val2, operator2, val3)
   *
   *   as it would change the behaviour if the operators are incomplete
   */
  if (operator2 !== 'around') {
    console.error("unknown second operator ".concat(operator2, " in precondition check"));
    return false;
  }

  var geolocation = getValueFromStringValue(val1);
  var radiusInMeter = getRadiusInMetersFromString(val2);
  var referenceLocation = getValueFromStringValue(val3);

  if (!geolocation || !referenceLocation) {
    return false;
  }

  return !_GeolocationHelper["default"].isInRadius(geolocation, referenceLocation, radiusInMeter);
};

var setTimer = function setTimer(val) {
  var now = (0, _now["default"])();
  var timerTime = val - now + 1000;
  var timerHours = timerTime / 1000 / 60 / 60;

  if (!timers[val] && timerHours < 24) {
    timers[val] = window.setTimeout(function () {
      var updateValue = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE) || 0;

      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE, updateValue + 1);

      delete timers[val];
    }, timerTime);
  }
};

var checkDateAfterNow = function checkDateAfterNow(val1) {
  var val = getValueFromStringValue(val1);
  var now = (0, _now["default"])();

  if (val > now) {
    setTimer(val);
  }

  return val <= now;
};

var checkDateBeforeNow = function checkDateBeforeNow(val1) {
  var val = getValueFromStringValue(val1);
  var now = (0, _now["default"])();

  if (val > now) {
    setTimer(val);
  }

  return val >= now;
};

var daysAfterStartDateAtTime = function daysAfterStartDateAtTime(val1, val2) {
  var startStr = _DataStore["default"].getElementByPathImmediately(_config["default"].startDatePath) || '';
  var daysAfter = getValueFromStringValue(val1);
  var timeAfter = getValueFromStringValue(val2);

  if (!startStr) {
    return false;
  } else {
    var correctedDate = new Date(startStr);
    correctedDate.setUTCDate(correctedDate.getDate() + daysAfter);
    correctedDate.setUTCSeconds(0);
    var timeArr = timeAfter.split(':');
    var hours = timeArr[0];
    var minutes = timeArr[1];
    correctedDate.setUTCHours(hours);
    correctedDate.setUTCMinutes(minutes);
    var now = new Date();

    if (now >= correctedDate) {
      return true;
    } else {
      setTimer(correctedDate.getTime());
    }

    return false;
  }
};

var opFunMap = {
  '==': checkEquals,
  '!=': checkNotEqual,
  '>': checkGreaterThan,
  '>=': checkGreaterOrEqual,
  '<': checkLessThan,
  '<=': checkLessOrEqual,
  'matches': checkMatches,
  'doesNotMatch': checkNotMatches,
  'isEmpty': checkIsEmpty,
  'isNotEmpty': checkIsNotEmpty,
  'exists': checkExists,
  'doesNotExist': checkDoesNotExist,
  'includesFeature': arrayIncludesFeature,
  'includes': arrayIncludes,
  'notIncludes': arrayNotIncludes,
  'isInRadius': checkGeolocationInRadius,
  'isNotInRadius': checkGeolocationNotInRadius,
  'isAfterNow': checkDateAfterNow,
  'isBeforeNow': checkDateBeforeNow,
  'daysAfterStartDateAtTime': daysAfterStartDateAtTime
};

var PreconditionChecker = /*#__PURE__*/function () {
  function PreconditionChecker() {
    (0, _classCallCheck2["default"])(this, PreconditionChecker);
  }

  (0, _createClass2["default"])(PreconditionChecker, null, [{
    key: "_checkCondition",
    value: function _checkCondition(condition) {
      // console.log('checking condition', condition)
      if (!condition) {
        return true;
      } // parse condition


      var fragments = condition.trim().split(' ');
      var value1;
      var operator1;
      var value2;
      var operator2;
      var value3;

      if (fragments.length >= 2) {
        value1 = fragments[0];
        operator1 = fragments[1];
      }

      if (fragments.length >= 3) {
        value2 = fragments[2];
      }

      if (fragments.length >= 4) {
        operator2 = fragments[3];
      }

      if (fragments.length >= 5) {
        value3 = fragments[4];
      } // noinspection UnnecessaryLocalVariableJS (reason: better to read)


      if (!opFunMap[operator1]) {
        console.error("Precondition uses operator ".concat(operator1, " which is not supported. -> Condition considered as failed."), condition);
        return false;
      } // noinspection UnnecessaryLocalVariableJS  better readability


      var passed = opFunMap[operator1](value1, value2, operator2, value3); // console.log('checking condition 1', condition, passed)

      return passed;
    }
  }, {
    key: "check",
    value: function check(preconditionsJsonBlock) {
      if (!preconditionsJsonBlock.active) {
        return true;
      }

      if (preconditionsJsonBlock.conditions) {
        return Boolean(preconditionsJsonBlock.conditions.find(function (conditions) {
          return conditions.every(function (condition) {
            return PreconditionChecker._checkCondition(condition);
          });
        }));
      }

      if (!preconditionsJsonBlock.checks) {
        return false;
      }

      return preconditionsJsonBlock.checks.every(function (condition) {
        return PreconditionChecker._checkCondition(condition);
      });
    }
  }]);
  return PreconditionChecker;
}();
/**
 *  Returns null if all conditions passed successfully or the first failing precondition block.
 */


var getFailingPrecondition = function getFailingPrecondition(preconditionsJson) {
  var _context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (_context) {
    context = _context;
  }

  if (preconditionsJson) {
    var preconditionsArray = [];

    if ((0, _isArray["default"])(preconditionsJson)) {
      preconditionsArray = preconditionsJson;
    } else if (preconditionsJson.otherPreconditions) {
      var otherPreconditions = preconditionsJson.otherPreconditions;
      preconditionsArray = [preconditionsJson].concat((0, _toConsumableArray2["default"])(otherPreconditions));
    } else {
      preconditionsArray = [preconditionsJson];
    }

    for (var i = 0; i < preconditionsArray.length; i++) {
      if (!PreconditionChecker.check(preconditionsArray[i])) {
        return preconditionsArray[i];
      }
    }
  }

  return null;
}; // deprecated for a long time now
//export const checkPreconditions = (preconditionsJson) => {
//  console.error('checkPreconditions is removed, use getFailingPrecondition instead!')
//  throw new Error('checkPreconditions is removed, use getFailingPrecondition instead!')
//}


exports.getFailingPrecondition = getFailingPrecondition;

var continueIfPreconditionFailed = function continueIfPreconditionFailed(preconditionJson) {
  return !preconditionJson || preconditionJson.continueOnFail === true; // don't remove the explicit check on true
};

exports.continueIfPreconditionFailed = continueIfPreconditionFailed;